import BrowserUtils from './browser';
import DateUtils from './date';
import DOMUtils from './dom';
import CalcUtils from './calc';
import CommonUtils from './common';
import ConstantManage from './constant';

const Utils = Object.assign(
    BrowserUtils,
    DateUtils,
    DOMUtils,
    CommonUtils,
    ConstantManage,
    CalcUtils
);

export default Utils;
